import React, {PureComponent} from 'react'
import {userLogout} from '../actions/AuthActions'
import {connect} from 'react-redux'

class StatusForbidden extends PureComponent {
  handleLogout = () => {
    this.props.dispatch(userLogout());
    this.props.history.push('/');
  };

  render() {
    return (
      <div className="Forbidden">
        <h3>Você não tem permissão para acessar essa área.</h3>
        <button className="btn btn-primary btn-lg" onClick={this.handleLogout}>
          SAIR
        </button>
      </div>
    );
  }
}

export default connect()(StatusForbidden);



// WEBPACK FOOTER //
// ./src/screens/StatusForbidden.js